/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DocMasterControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/document`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/document`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/document`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/document`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/document`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/document`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importDocMaster
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importDocMasterUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importDocMasterUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importDocMasterUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importDocMasterUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/document`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
